import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sign_form" }
const _hoisted_4 = { class: "imp" }
const _hoisted_5 = { class: "file_wrap imp" }
const _hoisted_6 = { for: "file_file_thumbnail" }
const _hoisted_7 = { class: "thumbnail_preview" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "file_wrap imp" }
const _hoisted_10 = { for: "area_file" }
const _hoisted_11 = { class: "file_list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "file_name" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "_flex _center btn_wrap" }
const _hoisted_17 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, "자료집 " + _toDisplayString($setup.state.idx === 0 ? "등록" : "수정"), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.title) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.data.title]
            ])
          ]),
          _createElementVNode("li", _hoisted_5, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "form_li_tit" }, "썸네일", -1)),
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("input", {
                id: "file_file_thumbnail",
                type: "file",
                placeholder: "",
                accept: "image/*",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changethumbnail && $setup.changethumbnail(...args)))
              }, null, 32),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: $setup.state.data.thumbnail ? $setup.state.data.thumbnail : '',
                  alt: "",
                  onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.CommonUtils.errorImg && $setup.CommonUtils.errorImg(...args)))
                }, null, 40, _hoisted_8)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "p_info" }, "위 이미지 영역을 클릭해주세요.", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "p_info" }, "50M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
            ])
          ]),
          _createElementVNode("li", _hoisted_9, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("input", {
                id: "area_file",
                type: "file",
                placeholder: "",
                multiple: "",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
              }, null, 32),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "p_info" }, "각 파일은 200MB 이하로 업로드 가능합니다. (최대 5개)", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: idx
                }, [
                  _createElementVNode("span", {
                    class: "file_name",
                    onClick: ($event: any) => ($setup.downloadFile(item.file, item.fileRealName))
                  }, _toDisplayString(item.fileRealName), 9, _hoisted_12),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.fileRemove(item.idx))
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_13)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap",
                    onClick: ($event: any) => ($setup.removeFile(index))
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("img", {
                      src: "img/close_02.png",
                      alt: ""
                    }, null, -1)
                  ]))], 8, _hoisted_15)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "submit_btn _130 _main_blue",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args))),
            textContent: _toDisplayString($setup.state.mode ? '등록' : '수정')
          }, null, 8, _hoisted_17)
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeDefaultModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}